import { render, staticRenderFns } from "./MachinesChipsCard.vue?vue&type=template&id=33e5125c&scoped=true"
import script from "./MachinesChipsCard.vue?vue&type=script&lang=js"
export * from "./MachinesChipsCard.vue?vue&type=script&lang=js"
import style0 from "./MachinesChipsCard.vue?vue&type=style&index=0&id=33e5125c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e5125c",
  null
  
)

export default component.exports